import React, { useState, useEffect, useMemo, useRef } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { Form, Offcanvas } from "react-bootstrap";
import '../../assets/css/Leads.css'
import { Link } from "react-router-dom";
import AddDeliveryBoy from "./Addbikestransfer";
import { toast, ToastContainer } from "react-toastify";
import { Tooltip } from "react-tooltip";
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
const imageUrl = "https://devapi.bykit.in/storage/users/";

const Bikestransfer = () => {
    const [leads, setLeads] = useState([]);
    const [search, setSearch] = useState("");
    const [rowsPerPage, setRowsPerPage] = useState(50); const [page, setPage] = useState(1);
    const [totalRows, setTotalRows] = useState(0);
    const [showOffcanvas, setShowOffcanvas] = useState(false);
    const [selectedLead, setSelectedLead] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showModal1, setShowModal1] = useState(false);
    const [latitude, setlatitude] = useState(null);
    const [longitude, setlongitude] = useState(null);
    const [did, setdid] = useState(null);


    const handleShowDetails = (lead) => {
        setSelectedLead(lead);
        setShowOffcanvas(true);
    }

    const offcanvasRef = useRef(null);


    let formattedPickupTime = ''
    if (selectedLead && selectedLead.pickup_time) {
        const pickup = new Date(selectedLead.pickup_time);
        formattedPickupTime = `${String(pickup.getDate()).padStart(2, '0')}-${String(pickup.getMonth() + 1).padStart(2, '0')}-${pickup.getFullYear()} ${String(pickup.getHours()).padStart(2, '0')}:${String(pickup.getMinutes()).padStart(2, '0')}`;
    }

    let formattedreachedTime = ''
    if (selectedLead && selectedLead.drop_time) {
        const reached = new Date(selectedLead.drop_time);
        formattedreachedTime = `${String(reached.getDate()).padStart(2, '0')}-${String(reached.getMonth() + 1).padStart(2, '0')}-${reached.getFullYear()} ${String(reached.getHours()).padStart(2, '0')}:${String(reached.getMinutes()).padStart(2, '0')}`;
    }


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                showOffcanvas &&
                offcanvasRef.current &&
                !offcanvasRef.current.contains(event.target)
            ) {
                setShowOffcanvas(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showOffcanvas]);


    const labels = [
        "Meter",
        "Front View",
        "Right Side",
        "Left Side",
        "Back Side",
        "Dents/Scratches"
    ];

    const center = useMemo(() => {
        return {
            lat: parseFloat(latitude),
            lng: parseFloat(longitude),
        };
    }, [latitude, longitude]);

    const [showForm, setShowForm] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [selectedBoy, setSelectedBoy] = useState(null);

    const mapContainerStyle = { width: '100%', height: '350px' };

    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: "AIzaSyCxtuQLTtr6G4ai6Tz-DiwB-rPKho3iHSs"
    });


    useEffect(() => {
        getLeadsData();
    }, []);

    const getLeadsData = async () => {
        const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
        const token = storedLoginData?.token;


        const url = "https://devapi.bykit.in/api/admin/get_biketransfer??type=live"
        const payload = {
            user_id: 1
        }
        try {
            const response = await axios.post(url, payload, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });
            console.log("All Bookings:", response.data);

            if (response.data?.data) {
                setLeads(response.data.data);
                setTotalRows(response.data.recordsTotal || 0);
            }
        } catch (error) {
            console.error("Error fetching data:", error.response?.data || error.message);
        }



    };
    const handlePageChange = (newPage) => setPage(newPage);
    const handleRowsPerPageChange = (newRows) => {
        setRowsPerPage(newRows);
        setPage(1);
    };

    const handleAcceptPayment = async (id) => {
        const confirmAction = window.confirm("Are you sure you want to accept this payment?");
        if (!confirmAction) return;

        const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
        const token = storedLoginData?.token;

        const payload = { id: id };

        try {
            const response = await axios.post(
                `https://devapi.bykit.in/api/admin/receivedpaymentbiketransfer??type=live`,
                payload,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            console.log('manager account ', response);

            if (response.data?.status) {
                toast.success("Successfully accepted");
                getLeadsData();
            }
        } catch (error) {
            console.error("Error updating status:", error.response?.data || error.message);
        }
    };


    const handleToggleStatus = async () => {
        if (!selectedBoy) return;
        const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
        const token = storedLoginData?.token;
        try {
            const response = await axios.get(
                `https://devapi.bykit.in/api/admin/delete_biketransfer/${selectedBoy.id}??type=live`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            console.log('manager account ', response)

            if (response.data?.status) {
                const message = "Workshop Successfully deleted";
                toast.success(message);
                getLeadsData();

                setShowModal(false);
            }
        } catch (error) {
            console.error("Error updating status:", error.response?.data || error.message);
        }
    };
    const columns = [
        {
            name: "Created Date",
            cell: (row) => (
                <div className="">
                    <p>{row.date || "N/A"}</p>
                </div>
            ),
            sortable: true,
        },
        {
            name: "Delivery boy",
            cell: (row) => (
                <div className="">
                    <p>{row.deliveryboy_name || "N/A"}</p>
                </div>
            ),
            sortable: false,
        },
        {
            name: "From Workshop",
            cell: (row) => (
                <div className="">
                    <p>{row.from_workshop_name || "N/A"}</p>
                </div>
            ),
            sortable: false,
        },
        {
            name: "To Workshop",
            cell: (row) => (
                <div className="">
                    <p>{row.to_workshop_name || "N/A"}</p>
                </div>
            ),
            sortable: false,
        },
        {
            name: "Bike Details",
            cell: (row) => (
                <div className="">
                    <p>{row.bike_details || "N/A"}</p>
                </div>
            ),
            sortable: false,
        },

        {
            name: "Charges",
            cell: (row) => (
                <div className="">
                    <p>{row.amount || "N/A"}</p>
                </div>
            ),
            sortable: false,
        },

        {
            name: "Status",
            cell: (row) => (
                <div className="">
                    <p>
                        {{
                            0: "Pending",
                            1: "Ongoing",
                            2: "Completed",
                            3: "Cancelled"
                        }[row.status] || "N/A"}
                    </p>
                </div>
            ),
            sortable: false,
        },


        {
            name: "Action",
            cell: (row, index) => (
                <div className="d-flex justify-content-end">


                    <div className="d-flex justify-content-end">
                        <button className="edit_btn me-2"
                            data-tooltip-id={`view-tooltip-${row.id}`}
                            data-tooltip-content="View Details"
                            onClick={() => handleShowDetails(row)}>
                            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className="me-1 iconify iconify--heroicons" width="1em" height="1em" viewBox="0 0 24 24">
                                <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
                                    <path d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178c.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178"></path>
                                    <path d="M15 12a3 3 0 1 1-6 0a3 3 0 0 1 6 0"></path>
                                </g>
                            </svg>
                        </button>
                        <Tooltip id={`view-tooltip-${row.id}`} place="top" className="tooltip_bg" />
                    </div>



                    <div className="d-flex justify-content-end">
                        <Tooltip id={`view-tooltip-${row.id}`} place="top" className="tooltip_bg" />
                        <button className="edit_btn me-2"
                            data-tooltip-id={`edit-tooltip-${row.id}`}
                            data-tooltip-content="Edit"
                            onClick={() => {
                                setSelectedBoy(row);
                                setShowForm(true);
                            }}>
                            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="iconify iconify--heroicons" width="1em" height="1em" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m16.862 4.487l1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"></path></svg>
                        </button>

                        <button className="edit_btn me-2"
                            data-tooltip-id={`edit-tooltip-${row.id}`}
                            data-tooltip-content="Delete"
                            onClick={() => {
                                setSelectedBoy(row);
                                setShowModal(true);

                            }}>
                            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="iconify iconify--heroicons me-1 ri-close-fill" width="0.8em" height="0.8em" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21q.512.078 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48 48 0 0 0-3.478-.397m-12 .562q.51-.088 1.022-.165m0 0a48 48 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a52 52 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a49 49 0 0 0-7.5 0"></path></svg>
                        </button>








                        <Tooltip id={`edit-tooltip-${row.id}`} place="top" className="tooltip_bg" />
                        {/* <button
                            className="workshop_btn"
                            data-tooltip-id={`status-tooltip-${row.id}`}
                            data-tooltip-content={row.status === 1 ? "Deactivate" : "Activate"}
                            onClick={() => {
                                setSelectedIndex(index);
                                setSelectedLead(row); // Store the clicked row
                                setShowModal(true);
                            }}
                        >
                            {row.status === 1 ? (
                                <i className="ri-close-fill" style={{ color: "#475569" }}></i>
                            ) : (
                                <i className="ri-check-fill" style={{ color: "#475569" }}></i>
                            )}
                        </button> */}

                        <Tooltip
                            id={`status-tooltip-${row.id}`}
                            place="top"
                            className={row.status === 1 ? "tooltip-activate" : "tooltip-deactivate"}
                        />


                    </div>
                    {row.payment_status == 0 ?
                        <div className="d-flex justify-content-end">
                            <button
                                className="edit_btn me-2"
                                data-tooltip-id={`payment-tooltip-${row.id}`}
                                data-tooltip-content="Accept Payment"
                                onClick={() => handleAcceptPayment(row.id)} // <-- You define this function
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" className="iconify iconify--heroicons" width="1em" height="1em" viewBox="0 0 24 24">
                                    <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M3 8h18M7 12h2m3 4h6m-6 0v-2a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m-2 4H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2Z" />
                                </svg>
                            </button>
                            <Tooltip id={`payment-tooltip-${row.id}`} place="top" className="tooltip_bg" />

                        </div> : null
                    }


                </div>
            ),
        },
    ];

    return (
        <div className="container data-table-container p-2">
            <ToastContainer></ToastContainer>
            {!showForm && (
                <div>
                    <div className="d-flex align-items-center gap-3">
                        <svg className="custom-icon" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="20px" height="20px" viewBox="0 0 24 24">
                            <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m3 12l2-2m0 0l7-7l7 7M5 10v10a1 1 0 0 0 1 1h3m10-11l2 2m-2-2v10a1 1 0 0 1-1 1h-3m-6 0a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1m-6 0h6"></path>
                        </svg>

                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="18px" height="18px" viewBox="0 0 24 24">
                            <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m8.25 4.5l7.5 7.5l-7.5 7.5"></path>
                        </svg>

                        <p className="m-0">Bikes Transfer</p>
                    </div>
                    <div className='managebrand_box mt-3 mb-2 pt-4 pb-1'>
                        <div>
                            <h4 className='dashboard_head ps-3 pb-4'>Bikes Transfer</h4>
                        </div>
                        <hr></hr>

                        <div className="container-fluid mt-3 px-3">
                            <div className="row align-items-center gy-2">
                                <div className="col-12 col-md-7 d-flex flex-column flex-md-row align-items-start">
                                    <input
                                        type="text"
                                        placeholder="Search by keyword"
                                        className="search-input1 me-md-2 mb-2 mb-md-0 w-100"
                                        style={{ padding: '8px',maxWidth:'280px'}}
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                    />
                                </div>

                                <div className="col-12 col-md-5 d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-md-end">
                                    <button className="add_workshop_btn me-3 w-100 w-md-auto" onClick={() => setShowForm(!showForm)} style={{ maxWidth:'280px'}}>
                                        +Add a Bike Transfer
                                    </button>
                                </div>

                            </div>
                        </div>
                        <br/>




                        <DataTable
                            columns={columns}
                            data={leads.filter((item) => item.message && item.message.toLowerCase().includes(search.toLowerCase()))}
                            pagination
                            responsive
                            // paginationServer
                            //paginationTotalRows={totalRows}
                            paginationPerPage={rowsPerPage}
                            paginationRowsPerPageOptions={[50, 100, 200, 300, 400]}
                            onChangePage={handlePageChange}
                            onChangeRowsPerPage={handleRowsPerPageChange}
                            customStyles={{
                                headRow: { style: { backgroundColor: "#E2E8F0", color: "#475569", fontWeight: "bold" } },
                                pagination: { style: { borderTop: "1px solid #ddd", padding: "10px", backgroundColor: "#f8f9fa" } },
                                cells: {
                                    style: {
                                        padding: "5px", // Reduces space between columns
                                        margin: "0",
                                    },
                                },
                                headCells: {
                                    style: {
                                        padding: "10px", // Reduces space in header cells
                                        margin: "0",
                                    },
                                },
                            }}
                        />
                    </div>

                </div>
            )}
            {/* Modal */}
            {showModal && (
                <div className="modal-overlay delete-overlay">
                    <div className="modal-content delete-content">
                        <div className="modal-header bg-dark text-white mt-0">
                            <button type="button" className="btn-close btn-close-white" onClick={() => setShowModal(false)}></button>
                        </div>
                        <div className='p-3'>
                            <p className="delete_text">
                                Are you sure you want to delete this workshop?
                            </p>
                        </div>
                        <hr className='p-0 m-0'></hr>
                        <div className="modal-buttons text-end p-3">
                            <button onClick={() => setShowModal(false)} className='model_dlt_btn me-3'>No</button>
                            <button onClick={handleToggleStatus} className='model_dlt_btn'>Yes</button>
                        </div>
                    </div>
                </div>
            )}



            {showForm && <AddDeliveryBoy setShowForm={setShowForm} refreshManagers={getLeadsData} selectedBoy={selectedBoy} />}



            <div>
                <Offcanvas className="custom-offcanvas" show={showOffcanvas} onHide={() => setShowOffcanvas(false)} placement="end">
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title></Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body ref={offcanvasRef}>
                        {selectedLead && (

                            <div className="lead-details" ref={offcanvasRef}>

                                <div className="row">
                                    {selectedLead.pickup_photos && (
                                        <div className="col-lg-10 col-md-10 col-sm-10 col-12">
                                            <div className="mt-4">
                                                <h4 className="detail_title">At the time of pickup</h4>
                                                <div className="d-flex flex-wrap">
                                                    {selectedLead.pickup_photos.split(",").map((photo, index) => (
                                                        <div style={{ marginRight: 8 }}>
                                                            {labels[index] || `Photo ${index + 1}`}
                                                            <Link
                                                                key={index}
                                                                to={`${imageUrl}${photo}`}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                style={{ marginRight: 10 }}
                                                            >
                                                                <img
                                                                    src={`${imageUrl}${photo}`}
                                                                    alt=""
                                                                    className="pick_photo"
                                                                    onError={(e) => (e.target.style.display = "none")}
                                                                />
                                                            </Link>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    )}


                                    {selectedLead.pickup_time && (
                                        <div className="col-lg-2 col-md-2 col-sm-2 col-12">
                                            <div className="mt-4">
                                                <h4 className="detail_title">Pickup Time</h4>
                                                <p className="detail_text">{formattedPickupTime}</p>
                                            </div>
                                        </div>
                                    )}

                                    {selectedLead.drop_photo && (
                                        <div className="col-lg-10 col-md-10 col-sm-10 col-12">
                                            <div className="mt-4">
                                                <h4 className="detail_title">Drop to workshop</h4>
                                                <div className="d-flex flex-wrap">
                                                    {selectedLead.drop_photo.split(",").map((photo, index) => (


                                                        <div style={{ marginRight: 8 }}>
                                                            {labels[index] || `Photo ${index + 1}`}
                                                            <Link
                                                                key={index}
                                                                to={`${imageUrl}${photo}`}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                style={{ marginRight: 10 }}
                                                            >
                                                                <img
                                                                    src={`${imageUrl}${photo}`}
                                                                    alt=""
                                                                    className="pick_photo"
                                                                    onError={(e) => (e.target.style.display = "none")}
                                                                />
                                                            </Link>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {selectedLead.drop_time && (
                                        <div className="col-lg-2 col-md-2 col-sm-2 col-12">
                                            <div className="mt-4">
                                                <h4 className="detail_title">Drop Time</h4>
                                                <p className="detail_text">{formattedreachedTime}</p>
                                            </div>
                                        </div>
                                    )}

                                    {selectedLead.message && (
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                                            <div className="mt-4">
                                                <h4 className="detail_title">Message</h4>
                                                <p className="detail_text">{selectedLead.message}</p>
                                            </div>
                                        </div>
                                    )}

                                </div>
                            </div>
                        )}
                    </Offcanvas.Body>
                </Offcanvas>
            </div>



        </div>
    );
};
export default Bikestransfer;